import palette from '../Theme/palette';

const getTypeColors = (type) => {
  const availableTypes = {
    info: {
      backgroundColor: palette.notification.info.background,
    },
    warning: {
      backgroundColor: palette.notification.warning.background,
    },
    error: {
      backgroundColor: palette.notification.error.background,
    },
    question: {
      backgroundColor: palette.notification.neutral.background,
    },
    success: {
      backgroundColor: palette.notification.valid.background,
    },
  };

  return availableTypes[type];
};

const getIconColors = (type: Type) => {
  const availableTypes = {
    info: {
      color: palette.notification.info.main,
    },
    warning: {
      color: palette.notification.warning.main,
    },
    error: {
      color: palette.notification.error.main,
    },
    question: {
      color: palette.notification.neutral.main,
    },
    success: {
      color: palette.notification.valid.main,
    },
  };

  return availableTypes[type];
};

const getDynamicIconStyles = (isSmall, type) => {
  if (!isSmall)
    return {
      ...getIconColors(type),
    };

  return {
    height: 20,
    width: 20,
    marginTop: '2px',
    ...getIconColors(type),
  };
};

export { getTypeColors, getDynamicIconStyles };
